import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 20v-16l-5 5","key":"svg-0"}],["path",{"d":"M18 20v-16l-5 5","key":"svg-1"}]]

const IconNumber11 = createReactComponent('outline', 'number-11', 'Number11', __iconNode);

export default IconNumber11;